import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import React from "react";
import { useAppSelector } from "@store/hooks";

const name = "NotificationsBar";

const NotificationsBar: React.FC = () => {
    const error = useAppSelector(({ ui }) => ui.SquareError)
    const info = useAppSelector(({ ui }) => ui.SquareInfo)
    const succeeded = useAppSelector(({ ui }) => ui.SquareSucceeded)
    const bookingCardSecured = useAppSelector(({ ui }) => ui.BookingCardSecured)

    return (
        (<Grid
            size={{
                xs: 12,
                sm: 12
            }}>
            <Paper elevation={2} sx={{ padding: 2, marginLeft: -1 }}>
                {succeeded && !error && !bookingCardSecured && <Alert severity="info"><Stack direction="row" sx={{ overflow: "hidden" }}>
                    PROCESSING... Card
                    <CircularProgress size={20} style={{ marginLeft: 10 }} />
                </Stack>
                </Alert>}
                {error && <Alert severity="error"> {error}</Alert>}
                {!succeeded && !error && <Alert severity="info">{info}</Alert>}
            </Paper>
        </Grid>)
    );
}

NotificationsBar.displayName = name;

export default React.memo(NotificationsBar);